import { ErrorWrapper, ResponseWrapper } from '../util'
import { BaseService } from './../base'

export class RemitentService extends BaseService {
  static get entity () {
    return 'remitent'
  }
  static get name () {
    return 'remitent'
  }

  static async getRemitentFindByType (typeRemitentId) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/find_by_type_remitent_id/${typeRemitentId}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }
}